export const cardList = [
    {
        badge : false,
        image : "https://cimages.milaap.org/milaap/image/upload/c_fill,h_198,w_264/v1663660274/production/images/campaign/568791/IMG-20220919-WA0022_pfkowf_1663661020.jpg",
        title : "Save GauMata from Lumpi Skin Disease 🙏",
        percent : 100,
        amount : "5,75,021",
        createdby : "Jai Sai Ram",
        details : "Receive  tax benefits  by donating to this cause"
    },

    {
        badge : true,
        image : "https://cimages.milaap.org/milaap/image/upload/c_fill,g_faces,h_198,w_264/v1661095595/production/images/campaign/553835/nuvjufeu6mct6jcba4ie_1661095598.jpg",
        title : "Aravind (TR) Srinivasan Birthday Fundraiser For Nellai Cancer Hospital",
        percent : 19,
        amount : "9,27,145",
        createdby : "Thaurvia A",
        details : false
    },

    {
        badge : false,
        image : "https://cimages.milaap.org/milaap/image/upload/c_fill,h_198,w_264/v1662057856/production/images/campaign/560210/WhatsApp_Image_2022-08-23_at_11.09.32_PM_euhf9j_1662058667.jpg",
        title : "Support Poor and Needy Children for Education",
        percent : 38,
        amount : "1,84,635",
        createdby : "Anonymous",
        details : false
    },

    {
        badge : false,
        image : "https://cimages.milaap.org/milaap/image/upload/c_fill,h_198,w_264/v1663164766/production/images/campaign/565902/IMG-20220914-WA0028_ub2hpe_1663164771.jpg",
        title : "Food Seva for the Needy. ",
        percent : 39,
        amount : "1,93,134",
        createdby : "Khushoor P...",
        details : false
    },

    {
        badge : true,
        image : "https://cimages.milaap.org/milaap/image/upload/c_fill,g_faces,h_198,w_264/v1660465894/production/images/campaign/549882/WhatsApp_Image_2022-08-14_at_1.06.26_PM_dldjfd_1660465898.jpg",
        title : "Urgent needs support for 1year baby Yuvraj",
        percent : 47,
        amount : "5,60,054",
        createdby : "Khushoor P...",
        details : "Receive  tax benefits  by donating to this cause"
    },

    {
        badge : true,
        image : "https://cimages.milaap.org/milaap/image/upload/c_fill,h_198,w_264/v1663089110/production/images/campaign/565577/IMG_2697_mamr67_1663092105.jpg",
        title : "Sponsor girls education at Ikhvelos in rural communities of Rajasthan",
        percent : 78,
        amount : "6,63,054",
        createdby : "Sirin Swan..",
        details : "Receive  tax benefits  by donating to this cause"
    },
]